export const name = '@lifi/sdk';
export const version = '3.13.2';
//# sourceMappingURL=version.js.map